import { render, staticRenderFns } from "./ScoresTable.vue?vue&type=template&id=44bd905b&scoped=true&"
import script from "./ScoresTable.vue?vue&type=script&lang=js&"
export * from "./ScoresTable.vue?vue&type=script&lang=js&"
import style0 from "./ScoresTable.vue?vue&type=style&index=0&id=44bd905b&prod&lang=scss&"
import style1 from "./ScoresTable.vue?vue&type=style&index=1&id=44bd905b&prod&lang=scss&"
import style2 from "./ScoresTable.vue?vue&type=style&index=2&id=44bd905b&prod&lang=scss&scoped=true&"
import style3 from "./ScoresTable.vue?vue&type=style&index=3&id=44bd905b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd905b",
  null
  
)

export default component.exports